import * as i0 from "@angular/core";
export class QueryParamsLsStore {
}
QueryParamsLsStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function QueryParamsLsStore_Factory() { return new QueryParamsLsStore(); }, token: QueryParamsLsStore, providedIn: "root" });
export var QueryParamsLsStoreKeys;
(function (QueryParamsLsStoreKeys) {
})(QueryParamsLsStoreKeys || (QueryParamsLsStoreKeys = {}));
